import { Store } from 'redux';
import { ErrorTypes, LoadDataReject } from 'types/load-data-reject-reason';
import { pageModelFetchRequest, selectPageModelNetwork } from '../../store/pageModel';
import { getPath, getSearch } from 'selectors';
import { hasInStoreServiceWithShop } from './instore-check';

export const RootPageLoadData = (store: Store) =>
	new Promise<void>((resolve, reject: LoadDataReject) => {
		store.dispatch(pageModelFetchRequest());

		const storeData = store.getState();
		const search = getSearch(storeData);
		const path = getPath(storeData);

		const isInStore = !!search && hasInStoreServiceWithShop(path);

		const unsub = store.subscribe(() => {
			const pageModelNetwork = selectPageModelNetwork(store.getState());

			if (pageModelNetwork.isFetched) {
				unsub();
				if (pageModelNetwork.isFailed) {
					reject({
						type: ErrorTypes.PAGE_MODEL,
						message: 'Page model was not fetched',
						isInStore,
					});
				} else {
					resolve();
				}
			}
		});
	});
